import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { InternalSsoProvider } from '@baltlife/internal-sso-react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import OAuthCallback from './auth/OAuthCallback';
import { RequireAuth } from './auth/RequireAuth';
import { sso } from './auth/sso';
import { SignOut } from './components/Authentication/SignOut/SignOut';
import { TitledCircularProgress } from './components/Feedback/TitledCircularProgress/TitledCircularProgress';
import Layout from './components/Layout/Layout';
import { theme } from './components/Theme/Theme';
import Error from './pages/Error/Index/Error';

import './custom.css';

const UserApp = React.lazy(() => import('./UserApp'));

export default function App() {
  return (
    <InternalSsoProvider sso={sso}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Routes>
            {/* Sessionless routes render without the guard or the app shell. */}
            <Route path="/oauth/callback" element={<OAuthCallback />} />
            <Route path="/Error/*" element={<Error />} />
            <Route path="/SignOut/*" element={<SignOut />} />
            <Route
              path="/*"
              element={
                <RequireAuth>
                  <Layout>
                    <Suspense
                      fallback={
                        <TitledCircularProgress title="Loading Page Content" />
                      }
                    >
                      <UserApp />
                    </Suspense>
                  </Layout>
                </RequireAuth>
              }
            />
          </Routes>
        </ThemeProvider>
      </StyledEngineProvider>
    </InternalSsoProvider>
  );
}
